export const fetchSuggestions = async (payload) => {
    const response = await fetch('https://jvmvitbqsf.execute-api.us-east-2.amazonaws.com/dev/search-suggestion', {

    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Suggestion fetch failed: ${response.status} - ${errorText}`);
  }

  return await response.json();
};
